/**
 * Show/hide GWP breakdown sections based on current variant and promo code
 * @param {string} variantId
 * @param {string} promoCode
 */

function showGwpBreakdownSections(variantId, promoCode) {
  console.log('[GWP] showGwpBreakdownSections called with:', { variantId, promoCode });
  Array.from(document.querySelectorAll('.gwp-breakdown-section')).forEach(el => {
    if (el.classList.contains(`${variantId}-${promoCode}`)) {
      el.style.display = 'block';
      el.parentElement.style.display = 'block';
    } else {
      el.style.display = 'none';
      el.parentElement.style.display = 'none';
    }
  });
}

// Track the priority source for GWP
window.gwpPrioritySource = null;

/**
 * Change the current GWP selection and update breakdown UI
 * @param {string} variantId - Shopify variant ID for the gift product
 * @param {string} promoCode - Discount code for the gift
 * @param {string|null} source - Source of the call, if any (high priority sources take precedence)
 */
function changeGWP(variantId, promoCode, source = null) {
  const isPriority = source === 'abtasty';
  
  // Check if call is from a priority source - if so, set the flag
  if (isPriority) {
    window.gwpPrioritySource = source;
    console.log(`[GWP] Called by priority source (${source}), taking priority`);
  } else if (window.gwpPrioritySource) {
    // If a priority source has already called this function, ignore non-priority calls
    console.log(`[GWP] Ignoring non-priority call as ${window.gwpPrioritySource} has priority`);
    return;
  }

  // If only one is empty/missing (or they are otherwise invalid), it's an error for normal GWP operation.
  if (!variantId || !promoCode) {
    console.trace('[GWP] changeGWP called with incomplete params (one param missing or invalid).');
    return;
  }

  const originalPromoCode = `${promoCode}`;
  if (promoCode) {
    promoCode = `%2C${promoCode}`;
  }
  console.log('[GWP] changeGWP called with:', { variantId, promoCode, source });

  // Set global variables for cart logic as per GWP_Implementation.md
  window.gift_id = variantId;
  window.gift_code = promoCode;
  window.currentGWP = { variantId, promoCode };

  // Update breakdown sections
  showGwpBreakdownSections(variantId, originalPromoCode);

  updateGwpUiElements();
}

/**
 * Format price according to Shopify conventions
 * @param {number} price - Price in cents
 * @returns {string} - Formatted price string
 */
function formatPrice(price) {
  return `£${(price / 100)}`;
}

const journeyHeadingSelector = '.journey_widget .free-gift-heading';

function updateGwpUiElements(source) {
  const initialHeadingEl = document.querySelector(journeyHeadingSelector);
  const freeGiftWorth = document.querySelector('#free-gift-worth');
  const freeGiftSection = document.querySelector('#free-gift-section');

  console.log('[GWP] updateGwpUiElements called. CurrentGWP:', window.currentGWP, 'Initial headingEl:', initialHeadingEl);
  console.log('[GWP] updateGwpUiElements source', source)

  if (source == 'journey-off' || source == 'theme-off') {
    document.querySelectorAll(journeyHeadingSelector).forEach(el => {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });

    if (freeGiftWorth) {
      freeGiftWorth.style.display = 'none';
    }

    if (freeGiftSection) {
      freeGiftSection.style.display = 'none';
    }

    document.querySelectorAll('.journey-main-widget .free-gift-test').forEach(el => {
      el.setAttribute('hidden', 'true');
    });

    document.querySelectorAll('.journey-main-widget').forEach(widget => {
      widget.classList.remove('ab-free-gift-on');
      widget.classList.add('ab-free-gift-off');
    });

  } else {
      if (initialHeadingEl && window.currentGWP) {
        const giftVariant = window.giftVariants && window.giftVariants.find(g => g.id == window.currentGWP.variantId);
        if (giftVariant) {
          const formattedPrice = `£${(giftVariant.price / 100)}`;
          const expectedText = `plus FREE gifts worth ${formattedPrice}`;
          
          if (freeGiftWorth) {
            freeGiftWorth.style.display = 'block';
            freeGiftWorth.innerText = `Plus FREE gifts worth ${formattedPrice}`;  
          }
          console.log(`[GWP] Gift variant found. Expected text for heading: "${expectedText}"`);

          const currentHeadingEls = document.querySelectorAll(journeyHeadingSelector);
          if (currentHeadingEls.length) {
            currentHeadingEls.forEach((currentHeadingEl) => {
              currentHeadingEl.innerText = expectedText;
              currentHeadingEl.removeAttribute('hidden');
              currentHeadingEl.removeAttribute('aria-hidden');
              console.log(`[GWP] Set heading to: "${expectedText}", Not Hidden.`);
            });
          }

        } else {
          console.warn(`[GWP] Gift variant not found for ID: ${window.currentGWP?.variantId}. Hiding free gift heading.`);
          document.querySelectorAll(journeyHeadingSelector).forEach(el => {
            el.hidden = true;
          });
        }
      } else if (initialHeadingEl && !window.currentGWP) {
          console.log('[GWP] No currentGWP data, ensuring heading element is hidden.');
          document.querySelectorAll(journeyHeadingSelector).forEach(el => { el.hidden = true; });
      } else if (!initialHeadingEl && window.currentGWP) {
          console.warn('[GWP] Heading element .journey_widget .free-gift-heading not found, cannot update GWP text.');
      }
      
      // Show other GWP elements (journey)
      document.querySelectorAll('.journey-main-widget .free-gift-test').forEach(el => {
        el.removeAttribute('hidden');
      });
      
      // Show free gift section if it exists
      if (freeGiftSection) {
        freeGiftSection.style.display = 'block';
      }

      const scrollToFreeGiftSection = (e) => {
        e.preventDefault();
        // Target the section by ID since that's what's in the HTML
        const targetSection = Array.from(document.querySelectorAll('#free-gift-section')).find(el => el.parentElement.style.display === 'block');
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }
      };
      // Set up click handler for free-gift-section-link
      const freeGiftSectionLink = document.getElementById('free-gift-section-link');
      if (freeGiftSectionLink) {
        freeGiftSectionLink.addEventListener('click', scrollToFreeGiftSection)
      }
      
      // Set up click handler for free-gift-section-link
      const freeGiftSectionSpan = document.querySelectorAll('.featured-product .gwp-text');
      if (freeGiftSectionSpan) {
        freeGiftSectionSpan.forEach(span => {
          span.addEventListener('click', scrollToFreeGiftSection)
        });
      }
      
      document.querySelectorAll('.journey-main-widget').forEach(widget => {
        widget.classList.add('ab-free-gift-on');
        widget.classList.remove('ab-free-gift-off');
      });
  }
}

/**
 * Per–product-widget GWP UI (symprove-product-widget-new). Uses section Liquid GWP + gift variant prices;
 * does not rely on window.journey_gwp_* or a single global currentGWP.
 * @param {{ sectionClass: string, enabled: boolean, variantId: string|number, promoCode: string, giftVariants?: Array<{id:number,price:number}> }} config
 */
function initProductWidgetGwp(config) {
  const { sectionClass, enabled, variantId, promoCode, giftVariants } = config || {};
  if (!sectionClass) return;

  const esc = typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
    ? CSS.escape(sectionClass)
    : String(sectionClass).replace(/\\/g, '\\\\').replace(/"/g, '\\"');

  const root = document.querySelector('.featured-product.' + esc);
  if (!root) {
    console.warn('[GWP] initProductWidgetGwp: .featured-product section not found:', sectionClass);
    return;
  }

  const giftPool = Array.isArray(giftVariants) && giftVariants.length
    ? giftVariants
    : (window.giftVariants || []);

  const headingSel = '.free-gift-heading';

  const setOff = () => {
    root.querySelectorAll(headingSel).forEach(el => {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });
    root.querySelectorAll('.gwp-filter-footer-line').forEach(el => {
      el.remove();
    });
    root.querySelectorAll('.gwp-usp-price-slot').forEach(el => {
      el.textContent = '';
    });
    root.classList.remove('ab-free-gift-on');
    root.classList.add('ab-free-gift-off');
  };

  if (!enabled || variantId == null || variantId === '' || !promoCode) {
    setOff();
    return;
  }
  console.log("giftPool", giftPool);
  const giftVariant = giftPool.find(g => String(g?.id ?? "") === String(variantId));
  if (!giftVariant) {
    console.warn('[GWP] Product widget: no gift variant price for id', variantId, '(pool length:', giftPool.length, ')');
    setOff();
    return;
  }

  const formattedPrice = `£${(giftVariant.price / 100)}`;
  const expectedText = ` plus FREE gifts worth ${formattedPrice}`;

  root.querySelectorAll(headingSel).forEach(el => {
    el.innerText = expectedText;
    el.removeAttribute('hidden'); 
    el.removeAttribute('aria-hidden');
  });
  root.querySelectorAll('.filter-footer ul').forEach(el => {
    if(el.closest('.ignore-gwp')) return;
    el.innerHTML += `<li class="gwp-filter-footer-line">Includes FREE gifts worth ${formattedPrice}</li>`;
  });
  root.querySelectorAll('.gwp-text').forEach(el => {
    if(el.closest('.ignore-gwp')) return;
    el.classList.remove('hidden')
    el.innerHTML += `Limited time only - FREE gifts worth ${formattedPrice}`;
  });
  root.querySelectorAll('.gwp-usp-price-slot').forEach(el => {
    el.textContent = `(worth ${formattedPrice})`;
  });
  root.classList.add('ab-free-gift-on');
  root.classList.remove('ab-free-gift-off');
}

window.initProductWidgetGwp = initProductWidgetGwp;

// Make functions available globally for theme.liquid inline usage
window.showGwpBreakdownSections = showGwpBreakdownSections;
window.changeGWP = changeGWP;
window.updateGwpUiElements = updateGwpUiElements;

// Single, global initialization
function gwpSingleInit() {
  console.log('[GWP] gwpSingleInit called');

  // Reset the priority source on initialization
  window.gwpPrioritySource = null;

  const hasJourneyOverride = typeof window.journey_gwp_enabled === 'boolean';
  const journeyEnabled = window.journey_gwp_enabled === true;
  const journeyDisabled = window.journey_gwp_enabled === false;

  if (journeyEnabled && window.journey_gwp_variant_id) {
    console.log('[GWP] Initializing from journey metafields (explicit ON)');
    const promoCode = window.journey_gwp_promo_code || ''; // Default to empty string
    const price = window.journey_gwp_price;
    changeGWP(window.journey_gwp_variant_id, promoCode, 'journey');
    return;
  }

  if (journeyDisabled) {
    console.log('[GWP] Journey page explicitly OFF — do not fall back to theme');
    window.currentGWP = null;
    changeGWP('', '', 'journey');
    updateGwpUiElements('journey-off');
    return;
  }

  // No journey override (undefined) → inherit from theme if available
  if (window.theme_gwp_enabled && window.theme_gwp_variant_id) {
    console.log('[GWP] No journey override — inheriting from theme settings');
    const promoCode = window.theme_gwp_promo_code || ''; 
    changeGWP(window.theme_gwp_variant_id, promoCode, 'theme');
    return;
  }

  console.log('[GWP] Nothing to initialize');
  window.currentGWP = null;
  updateGwpUiElements('theme-off');
}

document.addEventListener('DOMContentLoaded', gwpSingleInit);